var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-button-container"},[_c('img',{staticClass:"btn",attrs:{"src":require("../../assets/img/to-top.png")},on:{"click":_vm.goTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }